import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { passengerInformationInputModalReducer } from './passenger-information-input-modal.reducer';
import {
  PASSENGER_INFO_INPUT_MODAL_STORE_NAME,
  PassengerInformationInputModalState,
} from './passenger-information-input-modal.state';

/** Token of the PassengerInformationInputModal reducer */
export const PASSENGER_INFO_INPUT_MODAL_REDUCER_TOKEN = new InjectionToken<
  ActionReducer<PassengerInformationInputModalState, Action>
>('Feature PassengerInformationInputModal Reducer');

/** Provide default reducer for PassengerInformationInputModal store */
export function getDefaultPassengerInformationInputModalReducer() {
  return passengerInformationInputModalReducer;
}

@NgModule({
  imports: [StoreModule.forFeature(PASSENGER_INFO_INPUT_MODAL_STORE_NAME, PASSENGER_INFO_INPUT_MODAL_REDUCER_TOKEN)],
  providers: [
    { provide: PASSENGER_INFO_INPUT_MODAL_REDUCER_TOKEN, useFactory: getDefaultPassengerInformationInputModalReducer },
  ],
})
export class PassengerInformationInputModalStoreModule {
  public static forRoot<T extends PassengerInformationInputModalState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<PassengerInformationInputModalStoreModule> {
    return {
      ngModule: PassengerInformationInputModalStoreModule,
      providers: [{ provide: PASSENGER_INFO_INPUT_MODAL_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
